// German translations (default language).
const de = {
  app: {
    name: 'ewigbyte',
    tagline: 'Glass Archive Portal',
    adminTagline: 'Admin-Konsole',
    skipToContent: 'Zum Inhalt springen',
    logout: 'Abmelden',
    account: 'Konto',
    tenant: 'Mandant',
    theme: 'Darstellung',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    themeSystem: 'System',
    language: 'Sprache',
    languageGerman: 'Deutsch',
    languageEnglish: 'Englisch',
    openMenu: 'Navigation öffnen',
    closeMenu: 'Navigation schließen',
    roleUser: 'Benutzer',
    roleAdmin: 'Administrator',
  },
  nav: {
    dashboard: 'Übersicht',
    archives: 'Archive',
    upload: 'Hochladen',
    s3import: 'S3-Import',
    search: 'Suche',
    versions: 'Versionen',
    retention: 'Aufbewahrung',
    retrieval: 'Abruf',
    audit: 'Prüfberichte',
    billing: 'Abrechnung',
    notifications: 'Benachrichtigungen',
    sectionMain: 'Bereiche',
    sectionAdmin: 'Verwaltung',
    adminOverview: 'Übersicht',
    adminCustomers: 'Kunden',
    adminSubscriptions: 'Abonnements',
    adminPlans: 'Abo-Pläne',
    adminFlags: 'Feature-Flags',
    adminBuckets: 'Buckets',
    adminBurns: 'Brennvorgänge',
    adminBurnQueue: 'Freigaben',
    adminUsers: 'Benutzer',
    adminVerification: 'Verifikation',
  },
  common: {
    loading: 'Wird geladen …',
    retry: 'Erneut versuchen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    close: 'Schließen',
    save: 'Speichern',
    create: 'Erstellen',
    loadMore: 'Mehr laden',
    all: 'Alle',
    none: 'Keine',
    name: 'Name',
    createdAt: 'Erstellt',
    size: 'Größe',
    objects: 'Objekte',
    actions: 'Aktionen',
    details: 'Details',
    back: 'Zurück',
    search: 'Suchen',
    yes: 'Ja',
    no: 'Nein',
    unavailableTitle: 'Diese Funktion wird gerade fertiggestellt',
    unavailableBody:
      'Der zugehörige Dienst ist noch nicht verfügbar. Sobald er bereitsteht, erscheint dieser Bereich automatisch mit echten Daten — es werden keine Beispieldaten angezeigt.',
    errorTitle: 'Etwas ist schiefgelaufen',
    unauthorizedTitle: 'Anmeldung erforderlich',
    unauthorizedBody: 'Ihre Sitzung ist abgelaufen oder Sie sind nicht angemeldet.',
    login: 'Zur Anmeldung',
    emptyDefault: 'Keine Einträge vorhanden.',
    bytes: 'Bytes',
    copy: 'Kopieren',
    copied: 'Kopiert',
    optional: 'optional',
    required: 'Pflichtfeld',
  },
  quota: {
    title: 'Gekauftes Volumen',
    purchased: 'Gekauft',
    used: 'Auf Glas gebrannt',
    remaining: 'Verbleibend',
    staged: 'Hochgeladen, noch nicht gebrannt',
    hint: '{{percent}}% verbraucht über {{snapshots}} Snapshot(s). {{staged}} sind hochgeladen, aber noch nicht gebrannt — bereitgestellte Daten verbrauchen kein Volumen.',
    noQuota: 'Für dieses Konto ist kein gekauftes Volumen hinterlegt. Als verbraucht gilt nur auf Glas gebranntes Datenvolumen.',
    chart: {
      title: 'Speicherbelegung',
      burned: 'auf Glas gebrannt',
      staged: 'wartet auf Brennen',
      free: 'noch frei',
      ofPurchased: 'des gekauften Volumens',
      empty: 'Noch nichts hochgeladen oder gebrannt.',
      overQuota: 'Das gekaufte Volumen ist um {{over}} überschritten.',
      committedHint: '{{committed}} sind bereits vergeben — davon {{staged}} noch nicht gebrannt.',
    },
  },
  retention: {
    KEEP_ALL: 'Alle Versionen behalten',
    KEEP_LATEST: 'Nur neueste Version',
    KEEP_LAST_N: 'Letzte N Versionen',
    label: 'Aufbewahrungsrichtlinie',
    current: 'Aktuelle Richtlinie',
    change: 'Richtlinie ändern',
    changeTitle: 'Aufbewahrung ändern',
    warnTitle: 'Unwiderrufliche Aktion',
    warnBody:
      'Eine strengere Aufbewahrungsrichtlinie kann ältere Objektversionen dauerhaft zur Löschung freigeben. Dieser Vorgang lässt sich nicht rückgängig machen.',
    confirmChange: 'Richtlinie unwiderruflich ändern',
    pickArchive: 'Archiv wählen',
    updated: 'Aufbewahrungsrichtlinie aktualisiert.',
  },
  dashboard: {
    title: 'Übersicht',
    welcome: 'Willkommen zurück, {{name}}',
    subtitle: 'Ihr Glass-Archiv auf einen Blick.',
    totalArchives: 'Archive',
    totalObjects: 'Objekte',
    totalBytes: 'Gespeichert',
    recentActivity: 'Letzte Aktivität',
    noActivity: 'Noch keine Aktivität aufgezeichnet.',
    quickCreate: 'Neues Archiv',
    viewAll: 'Alle anzeigen',
    yourArchives: 'Ihre Archive',
  },
  archives: {
    title: 'Archive',
    subtitle: 'Verwalten Sie Ihre Archive und deren Inhalte.',
    create: 'Archiv erstellen',
    createTitle: 'Neues Archiv',
    nameLabel: 'Archivname',
    namePlaceholder: 'z. B. Buchhaltung 2026',
    empty: 'Sie haben noch keine Archive. Erstellen Sie Ihr erstes Archiv.',
    created: 'Archiv „{{name}}“ wurde erstellt.',
    colObjects: 'Objekte',
    colSize: 'Größe',
    colRetention: 'Aufbewahrung',
    deliverDmd: 'DMD ausliefern',
    deliverDmdHint: 'Erzeugt und lädt das DMD-Abbild (.dmd.tar.gz) dieses Archivs herunter.',
    detailTitle: 'Archivdetails',
    delete: 'Löschen',
    deleteConfirmTitle: 'Dieses Archiv löschen?',
    deleteConfirmBody: 'Löscht „{{name}}“ mit allen Objekten und Versionen unwiderruflich. Das kann nicht rückgängig gemacht werden.',
    deleted: 'Archiv gelöscht.',
    sync: 'Aus S3 synchronisieren',
    syncHint: 'Quell-Bucket erneut abrufen: neue und geänderte Objekte werden hinzugefügt; nichts wird gelöscht.',
    synced: 'Sync abgeschlossen — {{count}} Objekte verarbeitet.',
    syncedPartial: 'Sync nur teilweise: {{count}} Objekte übernommen, {{skipped}} übersprungen. Pro Lauf werden höchstens {{limit}} übertragen — erneut ausführen, um fortzusetzen.',
    syncFailed: 'Sync fehlgeschlagen.',
    syncTitle: 'Synchronisation',
    syncRunning: 'Läuft…',
    syncCounting: 'Quelle wird gelesen…',
    syncProgressLabel: 'Fortschritt der Synchronisation',
    syncObjects: '{{done}} von {{total}} Objekten',
    syncSkipped: '{{count}} übersprungen',
    syncState: {
      completed: 'Abgeschlossen',
      completed_partial: 'Teilweise abgeschlossen',
      failed: 'Fehlgeschlagen',
      running: 'Läuft…',
    },
  },
  snapshots: {
    requested: 'Brennanfrage eingereicht — sie wird geprüft und freigegeben.',
    alreadyRequested: 'Für dieses Archiv liegt bereits eine offene Anfrage vor.',
    requestTitle: 'Brennanfrage',
    requestedAt: 'Angefragt am {{when}} · {{volume}} · {{cost}}',
    requestNote: 'Hinweis',
    requestState: {
      requested: 'Wartet auf Freigabe',
      approved: 'Freigegeben',
      building: 'Abbild wird erzeugt…',
      rejected: 'Abgelehnt',
      failed: 'Fehlgeschlagen',
    },
    confirmTitle: 'Diesen Snapshot brennen?',
    confirmBody: 'Ein versiegeltes DMD-Abbild von „{{name}}“ wird auf Glas geschrieben. Das lässt sich nicht rückgängig machen.',
    confirmVolume: 'Zu brennendes Volumen',
    confirmCost: 'Geschätzte Kosten',
    confirmQuota: 'Verbleibendes Volumen',
    confirmNoPrice: 'Kein bepreister Tarif zugeordnet — es kann kein Betrag genannt werden.',
    quote: 'vsl. {{cost}}',
    rateLimited: 'Tägliches Schreiblimit erreicht — der Commit wurde abgelehnt. Nach dem Zurücksetzen des Limits erneut versuchen.',
    blockedHint: 'Ein Commit würde das tägliche Schreiblimit dieses Kontos überschreiten.',
    budgetLeft: 'Heute noch {{left}}',
    budgetExceeded: 'Benötigt {{need}}, heute nur noch {{left}}',
    title: 'Snapshots',
    subtitle: 'Versiegelte, gebrannte DMD-Abbilder dieses Archivs — jederzeit abrufbar.',
    burn: 'Jetzt sichern',
    burnHint: 'Versiegelt das Archiv und brennt einen Snapshot (DMD), den man später abrufen kann.',
    burned: 'Snapshot v{{seq}} gebrannt.',
    empty: 'Noch keine Snapshots. „Jetzt sichern“ nutzen oder einen zeitgesteuerten Commit einrichten.',
    colSeq: 'Version',
    colTrigger: 'Auslöser',
    colDmdSize: 'DMD-Größe',
    triggerManual: 'Manuell',
    triggerScheduled: 'Zeitgesteuert',
    retrieve: 'Abrufen',
  },
  schedule: {
    title: 'Zeitplan',
    subtitle: 'Sync und Commit (Brennen) automatisieren. Läuft ~02:00 UTC; monatlich am letzten Tag.',
    sync: 'Automatischer Sync',
    syncHint: 'S3-Quelle in diesem Rhythmus erneut abrufen.',
    commit: 'Automatischer Commit (Brennen)',
    commitHint: 'In diesem Rhythmus versiegeln und einen Snapshot brennen.',
    save: 'Zeitplan speichern',
    saved: 'Zeitplan gespeichert.',
    nextCommit: 'Nächster Commit: {{when}}',
    nextSync: 'nächster Sync: {{when}}',
    freq_off: 'Aus',
    freq_daily: 'Täglich',
    freq_weekly: 'Wöchentlich',
    freq_monthly: 'Monatlich',
    time: 'Uhrzeit',
    tz: 'Europe/Berlin',
    weekday: 'Wochentag',
    dayOfMonth: 'Tag im Monat',
    domLast: 'Letzter Tag',
    domNth: '{{n}}. Tag',
    wd_1: 'Montag',
    wd_2: 'Dienstag',
    wd_3: 'Mittwoch',
    wd_4: 'Donnerstag',
    wd_5: 'Freitag',
    wd_6: 'Samstag',
    wd_7: 'Sonntag',
    objectsTitle: 'Objekte',
    objectsEmpty: 'Dieses Archiv enthält noch keine Objekte.',
    colPath: 'Pfad',
    colVersions: 'Versionen',
    colHash: 'SHA-256',
    identifier: 'Kennung',
  },
  upload: {
    queued: '{{count}} Datei in Warteschlange',
    queued_other: '{{count}} Dateien in Warteschlange',
    quote: '{{size}} · vsl. {{cost}}',
    title: 'Hochladen',
    subtitle: 'Laden Sie Objekte in ein Archiv hoch. Mehrere Dateien und Wiederholung bei Fehlern werden unterstützt.',
    pickArchive: 'Zielarchiv',
    dropzone: 'Dateien hierher ziehen oder auswählen',
    dropzoneHint: 'Beliebig viele Dateien. Jede Datei wird einzeln mit Fortschritt übertragen.',
    choose: 'Dateien auswählen',
    startAll: 'Alle hochladen',
    clearDone: 'Fertige entfernen',
    statusQueued: 'In Warteschlange',
    statusUploading: 'Wird übertragen',
    statusDone: 'Fertig',
    statusError: 'Fehlgeschlagen',
    retry: 'Wiederholen',
    remove: 'Entfernen',
    abort: 'Abbrechen',
    noArchive: 'Bitte wählen Sie zuerst ein Zielarchiv.',
    needArchives: 'Sie benötigen mindestens ein Archiv, bevor Sie hochladen können.',
    createFirst: 'Archiv erstellen',
    doneToast: '{{count}} Datei erfolgreich hochgeladen.',
    doneToast_other: '{{count}} Dateien erfolgreich hochgeladen.',
  },
  s3import: {
    rate: '{{rate}} je geschriebenem GB · mind. {{min}} pro Datei',
    title: 'S3-Import',
    subtitle: 'Importieren Sie Objekte aus einem S3-kompatiblen Bucket.',
    sources: 'Bekannte Quellen',
    noSources: 'Keine vorkonfigurierten Quellen.',
    endpoint: 'Endpunkt',
    bucket: 'Bucket',
    prefix: 'Präfix',
    prefixPlaceholder: 'optionaler/pfad/',
    start: 'Import starten',
    started: 'Importauftrag {{id}} gestartet.',
    endpointPlaceholder: 'https://s3.example.com',
    bucketPlaceholder: 'mein-bucket',
    accessKey: 'Access Key',
    accessKeyPlaceholder: 'AKIA… / Access Key',
    secretKey: 'Secret Key',
    secretKeyPlaceholder: '••••••••',
    region: 'Region',
    credHint: 'Zugangsdaten sind für externe Buckets erforderlich. Nur für das plattformeigene MinIO leer lassen. Sie werden nur für diesen Import verwendet und nicht gespeichert.',
    doneTitle: 'Import abgeschlossen',
    doneInto: 'Objekte aus „{{bucket}}“ wurden in ein neues Archiv importiert.',
    imported: 'Importierte Objekte',
    openArchive: 'Archiv öffnen',
  },
  search: {
    title: 'Suche',
    subtitle: 'Suchen Sie nach Archiv- und Objektnamen.',
    placeholder: 'Nach Name oder Pfad suchen …',
    empty: 'Keine Treffer für „{{q}}“.',
    prompt: 'Geben Sie einen Suchbegriff ein, um zu beginnen.',
    colArchive: 'Archiv',
    colPath: 'Pfad',
    resultsCount: '{{count}} Treffer',
    resultsCount_other: '{{count}} Treffer',
  },
  versions: {
    title: 'Versionen',
    subtitle: 'Sehen Sie die Versionshistorie eines Objekts ein.',
    pickArchive: 'Archiv',
    pickObject: 'Objekt',
    colVersion: 'Version',
    empty: 'Für dieses Objekt sind keine Versionen vorhanden.',
    prompt: 'Wählen Sie ein Archiv und ein Objekt, um die Versionen anzuzeigen.',
    noObjects: 'Dieses Archiv enthält keine Objekte.',
  },
  retrieval: {
    title: 'Abruf',
    subtitle: 'Schätzen Sie Medien, Dauer und Kosten für den Abruf von Objekten.',
    pickArchive: 'Archiv',
    pickObjects: 'Objekte auswählen',
    estimate: 'Kostenschätzung anfordern',
    resultTitle: 'Schätzung',
    media: 'Benötigte Medien',
    days: 'Dauer',
    daysValue: '{{count}} Tag',
    daysValue_other: '{{count}} Tage',
    eur: 'Geschätzte Kosten',
    spanned: 'Achtung: Mindestens ein Objekt erstreckt sich über mehrere Medien (Spanned Object).',
    notSpanned: 'Kein Objekt erstreckt sich über mehrere Medien.',
    selectHint: 'Wählen Sie mindestens ein Objekt aus.',
    noObjects: 'Dieses Archiv enthält keine Objekte.',
    deliver: 'In S3-Bucket abrufen',
    delivering: 'Bucket wird bereitgestellt und Daten kopiert …',
    deliverHint: 'Erstellt einen eigenen S3-Bucket, kopiert die ausgewählten Objekte hinein und liefert zeitlich begrenzte Download-Links.',
    deliveredTitle: 'Abruf bereit',
    bucket: 'Auslieferungs-Bucket',
    endpoint: 'S3-Endpunkt',
    expires: 'Links gültig für {{count}} Stunden',
    download: 'Herunterladen',
    openConsole: 'In S3 öffnen',
  },
  audit: {
    title: 'Prüfberichte',
    subtitle: 'Nachvollziehbares, unveränderliches Prüfprotokoll.',
    colSeq: 'Nr.',
    colTime: 'Zeitpunkt',
    colActor: 'Akteur',
    colAction: 'Aktion',
    colResource: 'Ressource',
    colResult: 'Ergebnis',
    empty: 'Keine Prüfereignisse vorhanden.',
  },
  billing: {
    rateCard: 'Ihre Konditionen',
    rateWrite: 'Schreiben auf Glas',
    rateStorage: 'Speicherung',
    rateRead: 'Abruf',
    rateFreeReadouts: 'Freie Abrufe (Lebenszeit)',
    rateMinBillable: 'Mindest-abrechenbare Dateigröße',
    rateMinBillableHint: 'Kleinere Dateien werden mit dieser Größe berechnet.',
    perGb: '{{price}} / GB',
    perGbYear: '{{price}} / GB / Jahr',
    perReadout: '{{price}} / Abruf',
    noPlan: 'Diesem Konto ist kein bepreister Tarif zugeordnet — es können keine Konditionen angezeigt werden.',
    title: 'Abrechnung',
    subtitle: 'Medienbasierte Abrechnungsschätzung.',
    colPeriod: 'Zeitraum',
    colWritten: 'Geschriebene Medien',
    colRetrieved: 'Abgerufene Medien',
    colEur: 'Betrag',
    total: 'Gesamtsumme',
    empty: 'Keine Abrechnungsdaten vorhanden.',
    storagePerMonth: 'Speicher / Monat',
    pricedBy: 'Bepreist nach Plan',
  },
  notifications: {
    title: 'Benachrichtigungen',
    subtitle: 'Systemmeldungen und Ereignisse.',
    empty: 'Keine Benachrichtigungen.',
    markAll: 'Alle als gelesen markieren',
    unread: 'ungelesen',
  },
  admin: {
    overview: {
      title: 'Übersicht',
      subtitle: 'Plattformweite Kunden, Nutzung und Warnungen bei Grenzwertüberschreitung.',
      customers: 'Kunden',
      alerts: 'Ratenlimit-Warnungen',
      alertsEmpty: 'Kein Mandant ist nahe an seinem Ratenlimit.',
      stored: 'Gespeichert',
      objects: 'Objekte',
      scheduled: 'Geplante Buckets',
      snapshots: 'Snapshots',
      upcoming: 'Anstehend & überfällig',
      noUpcoming: 'Nichts geplant.',
      allOnTrack: 'Alles im Plan',
      overdueCount: '{{count}} überfällig',
      colWhen: 'Wann',
      colWhat: 'Was',
      colDate: 'Datum',
      planMix: 'Abonnements',
      recent: 'Letzte Aktivität',
      inMinutes: 'in {{count}} Min',
      inHours: 'in {{count}} Std',
      inDays: 'in {{count}} T',
      overdueBy: 'vor {{rel}}',
      kind: { sync: 'Sync', commit: 'Burn / Commit', verification: 'Verifikation' },
      colMetric: 'Metrik',
      colUsage: 'Nutzung',
      colPercent: '% des Limits',
    },
    burnQueue: {
      title: 'Freigaben',
      subtitle: 'Brennanfragen der Kunden. Erst nach Freigabe wird ein DMD erzeugt und auf Glas geschrieben.',
      pendingOnly: 'Nur offene Anfragen',
      empty: 'Keine Anfragen vorhanden.',
      emptyPending: 'Keine offenen Anfragen — nichts zu tun.',
      requested: 'Angefragt',
      volume: 'Volumen',
      cost: 'Angebot',
      status: 'Status',
      decision: 'Entscheidung',
      approve: 'Freigeben',
      reject: 'Ablehnen',
      approved: 'Freigegeben — das Abbild für „{{archive}}" wird jetzt erzeugt.',
      decidedBy: 'durch {{who}}',
      rejectTitle: 'Anfrage für „{{archive}}" ablehnen',
      reason: 'Begründung',
      reasonHint: 'Der Kunde bekommt diesen Text zu sehen.',
      reasonRequired: 'Bitte eine Begründung angeben.',
      state: {
        requested: 'Wartet auf Freigabe',
        approved: 'Freigegeben',
        building: 'Wird erzeugt…',
        completed: 'Gebrannt',
        rejected: 'Abgelehnt',
        failed: 'Fehlgeschlagen',
      },
    },
    burns: {
      title: 'Brennvorgänge',
      subtitle: 'Alle auf Glas gebrannten Abbilder über sämtliche Kunden hinweg — mit Prüfsumme als Nachweis.',
      searchPlaceholder: 'Kunde, Bucket oder Prüfsumme…',
      empty: 'Es wurde noch nichts gebrannt.',
      when: 'Zeitpunkt',
      customer: 'Kunde',
      bucket: 'Bucket',
      seq: 'Nr.',
      objects: 'Objekte',
      dmdSize: 'DMD-Größe',
      digest: 'Prüfsumme',
      trigger: 'Auslöser',
      by: 'Durch',
      triggerKind: { manual: 'Manuell', scheduled: 'Zeitplan' },
    },
    buckets: {
      create: 'Neuer Bucket',
      createTitle: 'Neuer Bucket',
      created: 'Bucket „{{name}}“ angelegt.',
      title: 'Buckets',
      subtitle: 'Alle Buckets über alle Kunden hinweg, mit Zeitplan und Snapshots.',
      filterPlaceholder: 'Nach Bucket oder Kunde filtern …',
      scheduledOnly: 'Nur geplante',
      empty: 'Keine Buckets gefunden.',
      emptyScheduled: 'Kein Bucket läuft nach Zeitplan.',
      colBucket: 'Bucket',
      colCustomer: 'Kunde',
      colSync: 'Sync',
      colCommit: 'Burn / Commit',
      colSnapshots: 'Snapshots',
      off: 'aus',
    },
    users: {
      title: 'Benutzer',
      subtitle: 'Identitäten, die auf der Plattform gehandelt haben — je Kunde.',
      sourceNote: 'Die Konten liegen in Keycloak. Hier steht die tatsächlich im Prüfprotokoll beobachtete Aktivität — ruhende Konten erscheinen nicht.',
      filterPlaceholder: 'Nach Benutzer oder Kunde filtern …',
      empty: 'Noch keine Aktivität aufgezeichnet.',
      colUser: 'Benutzer',
      colActions: 'Aktionen',
      colLastAction: 'Letzte Aktion',
      colLastSeen: 'Zuletzt gesehen',
      colFirstSeen: 'Erstmals gesehen',
      platformScope: 'Plattformweit',
    },
    override: {
      title: 'Tarif & Konditionen — {{name}}',
      hint: 'Jedes Feld zeigt den aktuell geltenden Wert. Ändern Sie nur das Vereinbarte; unberührte Felder folgen weiter dem Plan. Ein geleertes Feld entfernt einen bestehenden Override.',
      needPlan: 'Bitte zuerst einen Plan wählen.',
      group: { price: 'Preise', limit: 'Volumen & Limits', service: 'Service-Attribute' },
    },
    impersonation: {
      banner: 'Ansicht als „{{tenant}}“ — diese Sitzung ist zeitlich begrenzt und wird protokolliert.',
      exit: 'Beenden',
    },
    flags: {
      title: 'Feature-Flags',
      subtitle: 'Welcher Flag-Wert für welchen Kunden gilt — und woher er stammt.',
      overriddenOnly: 'Nur Kunden mit Override',
      empty: 'Keine Kunden vorhanden.',
      emptyOverridden: 'Kein Kunde hat einen Flag-Override.',
      clear: 'Zurücksetzen',
      clearHint: 'Override entfernen, sodass wieder der Planwert gilt.',
      cleared: 'Override entfernt.',
      override: 'Override',
      overrideHint: 'Kundenspezifischen Wert für dieses Flag setzen.',
      overrideTitle: 'Override für „{{name}}“',
      overrideSaved: 'Override gespeichert.',
    },
    verification: {
      title: 'Verifikation',
      subtitle: 'Wann die Medienverifikation je Kunde fällig ist — abgeleitet aus der Frequenz des Plans.',
      empty: 'Keine aktiven Abonnements zu planen.',
      colLast: 'Zuletzt verifiziert',
      colDue: 'Fällig',
      colState: 'Status',
      never: 'Nie',
      overdue: 'Überfällig',
      onTrack: 'Im Plan',
      unschedulable: 'Frequenz nicht erkannt',
      everyNDays: 'alle {{count}} Tage',
    },
    subscriptions: {
      title: 'Abonnements',
      subtitle: 'Plan-Zuweisung jedes Kunden. Wählen Sie eine Kohorte einer Planfamilie, um sie gemeinsam zu migrieren.',
      empty: 'Noch keine Abonnements.',
      migrateSelected: '{{count}} ausgewählte auf neueste Version migrieren',
      selectRow: '{{name}} auswählen',
      actionDone: 'Abonnement aktualisiert.',
      migrated: 'Ausgewählte Abonnements migriert.',
      previewTitle: 'Vorschau: {{count}} Kunde(n) migrieren',
      noChanges: 'Keine Änderungen für die aktuelle Auswahl.',
      noFieldChanges: 'Keine Feldänderungen für diesen Kunden — nur der Plan-Versionszeiger bewegt sich.',
      droppedOverrides: 'Diese Overrides existieren in der Zielversion nicht und werden verworfen: {{fields}}',
      colOld: 'Aktuell',
      colNew: 'Neu',
      confirmMigrate: 'Migration bestätigen',
    },
    customers: {
      title: 'Kunden',
      subtitle: 'Alle Mandanten mit Plan- und Bucket-Nutzung über die gesamte Plattform.',
      filterPlaceholder: 'Nach Name oder ID filtern …',
      empty: 'Keine Kunden gefunden.',
      create: 'Neue Organisation',
      createTitle: 'Neue Organisation',
      created: 'Organisation „{{name}}“ angelegt.',
      idLabel: 'Organisations-ID',
      idHint: 'Dauerhafter Schlüssel in Speicherpfaden und im OIDC-Tenant-Claim. Kleinbuchstaben, Ziffern und Bindestriche.',
      idRule: 'Nur Kleinbuchstaben, Ziffern und Bindestriche erlaubt.',
      colPlan: 'Plan',
      colStatus: 'Status',
      colBuckets: 'Buckets',
      nearLimit: 'bei {{percent}}% des Limits',
      overLimit: 'Limit überschritten ({{percent}}%)',
      refused: '{{count}}× heute abgelehnt',
      noPlan: 'Kein Abonnement',
    },
    customerDetail: {
      subtitle: 'Effektive Limits, Nutzung und Buckets dieses Kunden.',
      viewAs: 'Als Mandant ansehen',
      viewAsHint: 'Öffnet eine zeitlich begrenzte, protokollierte Sitzung im Kontext dieses Mandanten.',
      rename: 'Umbenennen',
      renameTitle: 'Organisation umbenennen',
      renamed: 'Organisation umbenannt.',
      idFixed: 'Die ID „{{id}}“ bleibt fest — Archive, Prüfprotokoll und Abonnement verweisen darauf.',
      editPlan: 'Tarif & Konditionen',
      assignPlan: 'Plan zuweisen',
      assigned: 'Abonnement aktualisiert.',
      effectiveLimits: 'Effektive Limits',
      colField: 'Feld',
      colValue: 'Wert',
      colSource: 'Quelle',
      usage: 'Nutzung',
      bytesWritten: 'Geschrieben (aktueller Zeitraum)',
      buckets: 'Buckets',
      bucketsEmpty: 'Dieser Kunde hat noch keine Buckets.',
    },
    plans: {
      title: 'Abo-Pläne',
      subtitle: 'Plankatalog — Bearbeiten ändert nie bestehende Abonnenten; jede Änderung erzeugt eine neue Version.',
      create: 'Neuer Plan',
      createTitle: 'Neuer Plan',
      newVersion: 'Neue Version',
      newVersionTitle: 'Neue Version von „{{name}}“',
      created: 'Plan erstellt.',
      versionCreated: 'Neue Version erstellt.',
      empty: 'Noch keine Pläne.',
      colVersion: 'Version',
      nameLabel: 'Planname',
      purchasedHint: 'Vom Kunden gekauftes Volumen. 0 = kein Kontingent vereinbart.',
      bytesHint: 'Menge und Einheit wählen.',
      listHint: 'Kommagetrennt',
    },
    assign: {
      title: 'Abonnement zuweisen',
      planLabel: 'Plan',
      planPlaceholder: 'Plan wählen …',
      overrideWrite: 'Override: Schreib-Ratenlimit (GB/Tag)',
      overrideRead: 'Override: Lese-Ratenlimit (GB/Tag)',
      overrideHint: 'Leer lassen für den Planstandard.',
    },
    status: {
      active: 'Aktiv',
      paused: 'Pausiert',
      cancelled: 'Gekündigt',
      actionPause: 'Pausieren',
      actionCancel: 'Kündigen',
      actionReactivate: 'Reaktivieren',
    },
    source: {
      plan: 'Plan',
      features: 'Features',
      override: 'Override',
    },
    fields: {
      unit: 'Einheit',
      resolvesTo: 'entspricht {{size}} ({{bytes}} Bytes)',
      writeSlaHours: 'Max. Zeit bis Glas-Schreibung (Stunden)',
      purchasedStorageBytes: 'Gekauftes Speichervolumen',
      minStoragePerArchiveBytes: 'Mindestspeichermenge pro Bucket',
      rateLimitWriteBytesPerDay: 'Schreib-Ratenlimit / Tag',
      rateLimitReadBytesPerDay: 'Lese-Ratenlimit / Tag',
      verificationLevel: 'Verifikationsstufe',
      verificationFrequency: 'Verifikationsfrequenz',
      retrievalOptions: 'Abrufoptionen',
      priceWriteEurPerGb: 'Schreibpreis (EUR/GB)',
      priceReadFreeLifetimeCount: 'Kostenlose Abrufe (Lebenszeit)',
      priceReadEurPerReadout: 'Lesepreis pro Abruf (EUR)',
      priceStorageEurPerGbYear: 'Speicherpreis (EUR/GB/Jahr)',
      physicalPackaging: 'Physische Verpackung',
      ttfbReadingHours: 'Time to First Byte (Stunden)',
      ttfbSiteId: 'Standort für Time-to-First-Byte',
      eccProfile: 'Erasure-Coding-Profil',
      storageLocationSiteId: 'Speicherstandort',
      minBillableObjectBytes: 'Mindest-abrechenbare Dateigröße',
      minBillableReadBytes: 'Mindest-abrechenbare Lesemenge',
      mediumRedundancyPercent: 'Medienredundanz (%)',
      writeTriggers: 'Schreib-Trigger',
    },
  },
} as const;

export default de;
